import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    url: '',
    userName: '',
    tabMeunData: {},
    assessAllData: [],
    assessNoData: [],
    assessProceedData: [],
    assessDoneData: [],
    assessPopUpShow: false,
    assessContainer: [],
    dataList: [],
    nameList: [],
    valueList: [],
    announcementIndex: -1,
    announcementBlockName: '',
    logoUrl: '',
    orgName: '',
    name: '',
    answerList: []
  },
  mutations: {
    handleAnswerList (state, payload) {
      state.answerList = payload;
    },
    handleDataList (state, payload) {
      state.dataList = payload;
    },
    handleNameList (state, payload) {
      state.nameList = payload;
    },
    handleValueList (state, payload) {
      state.valueList = payload;
    },
    handleAssessPopUpShow (state, payload) {
      state.assessPopUpShow = payload;
    },
    handleAssessContainer (state, payload) {
      state.assessContainer = payload;
    },
    handleUserName (state, payload) {
      state.userName = payload;
    },
    handleTabMeunData (state, payload) {
      state.tabMeunData = payload;
    },
    handleAssessAllData (state, payload) {
      state.assessAllData = payload;
    },
    handleAssessNoData (state, payload) {
      state.assessNoData = payload;
    },
    handleAssessProceedData (state, payload) {
      state.assessProceedData = payload;
    },
    handleAssessDoneData (state, payload) {
      state.assessDoneData = payload;
    }
  },
  actions: {
    handleAnswerList ({ commit }, payload) {
      commit('handleAnswerList', payload);
    },
    handleDataList ({ commit }, payload) {
      commit('handleDataList', payload);
    },
    handleNameList ({ commit }, payload) {
      commit('handleNameList', payload);
    },
    handleValueList ({ commit }, payload) {
      commit('handleValueList', payload);
    },
    handleAssessAllData ({ commit }, payload) {
      commit('handleAssessAllData', payload);
    },
    handleAssessNoData ({ commit }, payload) {
      commit('handleAssessNoData', payload);
    },
    handleAssessProceedData ({ commit }, payload) {
      commit('handleAssessProceedData', payload);
    },
    handleAssessDoneData ({ commit }, payload) {
      commit('handleAssessDoneData', payload);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js